import { type GradeCategoryWithLessons } from "@core/grades/types";
import { type BreadcrumbItem } from "@core/shared/types";
import { URLS } from "@core/shared/utils";
import { trans } from "@mongez/localization";
import { useMemo } from "react";

export function useCategoryDetailsPage(category: GradeCategoryWithLessons) {
  return useMemo(() => {
    const directLessons = category.lessons || [];
    const childCategories = category.children || [];
    const childCategoriesWithLessons = childCategories.filter(
      (child) => !!child.lessons?.length,
    );
    const childLessonsCount = childCategories.reduce(
      (total, child) => total + (child.lessons?.length || 0),
      0,
    );
    const calculatedLessonsCount = directLessons.length + childLessonsCount;
    const totalLessons =
      category.total?.lessons && category.total.lessons > calculatedLessonsCount
        ? category.total.lessons
        : calculatedLessonsCount;

    const breadcrumbs: BreadcrumbItem[] = [
      {
        text: category.grade?.name || trans("grades.title"),
        url: category.grade
          ? URLS.grades.view(category.grade)
          : URLS.grades.list,
      },
      {
        text: category.subject?.name || "",
        url: category.subject ? URLS.subjects.view(category.subject) : "",
      },
      {
        text: category.parent?.name || "",
        url: category.parent ? URLS.grades.viewCategory(category.parent) : "",
      },
      {
        text: category.name,
        url: URLS.grades.viewCategory(category),
      },
    ].filter((item) => !!item.url);

    return {
      breadcrumbs,
      childCategories,
      childCategoriesWithLessons,
      directLessons,
      hasContent: directLessons.length > 0 || childCategories.length > 0,
      totalLessons,
    };
  }, [category]);
}
